module.exports = {
    methods: {
        formatAmount(money, currency) {
            const value = Number.parseFloat(money);

            if (isNaN(value)) return '';

            const symbol = currency?.symbol || '£';

            return `${symbol} ${value.toFixed(2).replace('.', ',')}`;
        }
    }
}
